module.exports = __webpack_public_path__ + "fonts/Inter-700-greek67.eb1153e.woff2";